import $ from 'jquery';

/**
 * Enables the secondary checkbox when the primary checkbox is checked
 */
const conditionalEnable = function (primaryCheckbox, secondaryCheckbox) {
	const checked = $(primaryCheckbox).prop('checked');

	if (!checked) {
		$(secondaryCheckbox).prop('checked', false).prop('disabled', true);
	}

	$(primaryCheckbox).on('click', function () {
		const checked = $(this).prop('checked');
		$(secondaryCheckbox).prop('disabled', !checked);
		if (!checked) {
			$(secondaryCheckbox).prop('checked', false);
		}
	});
};

export { conditionalEnable };
